import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import SanityImage from "gatsby-plugin-sanity-image"
import Container from "components/Container"
import TextBlock from "components/TextBlock"
import theme from "styles/theme"

const SignatureTextBlock = ({ content, signatures }) => (
  <Container
    max={942}
    wrapperStyles={theme.expandQueries({
      padding: ["80px 74px", "60px 74px", "45px 40px"],
      ".articleBlock + &": {
        paddingTop: 0,
        marginTop: [-88, -60, -63],
      },
    })}
  >
    <TextBlock>{content}</TextBlock>

    <div
      css={{
        display: "flex",
        marginTop: 24,
        [theme.mobile]: {
          display: "block",
        },
      }}
    >
      {signatures.map(({ name, position, signature }, index) => (
        <div
          key={index}
          css={{
            "& + &": theme.expandQueries({ marginLeft: [120, 80, 0] }),
            [theme.mobile]: {
              marginTop: 24,
            },
          }}
        >
          <SanityImage
            {...signature}
            alt={`Signature of ${name}`}
            css={{
              height: 70,
              [theme.mobile]: {
                height: "auto",
                width: 170,
              },
            }}
            config={{ maxWidth: 300 }}
            height={70}
          />

          <div css={{ marginTop: 10 }}>
            <div css={{ fontWeight: 500 }}>{name}</div>
            {position && <div>{position}</div>}
          </div>
        </div>
      ))}
    </div>
  </Container>
)

export default SignatureTextBlock

SignatureTextBlock.propTypes = {
  content: PropTypes.array.isRequired,
  signatures: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      position: PropTypes.string,
      signature: PropTypes.shape({
        asset: PropTypes.object.isRequired,
      }).isRequired,
    }).isRequired
  ).isRequired,
}

export const query = graphql`
  fragment SignatureTextBlock on SanitySignatureTextBlock {
    content: _rawContent
    signatures {
      name
      position
      signature {
        ...Image
      }
    }
  }
`
